import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import BlogPost from "@/pages/BlogPost";

export const Route = createFileRoute("/es/blog/$slug")({
  loader: ({ params }) => loadContentMeta("blog_posts", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/blog/${params.slug}`, loaderData, params.slug === "eudravigilance-gestion-senales-enfoques" ? {
      title: "Gestión de Señales con EudraVigilance: Elige tu Enfoque | QbD Group",
      description: "Explora tres formas de integrar los datos de EudraVigilance en la gestión de señales, desde la validación y evaluación hasta la detección y el seguimiento basados en el riesgo.",
    } : params.slug === "variaciones-ue-grouping-worksharing" ? {
      title: "Variaciones en la UE: Guía Práctica sobre Grouping y Worksharing | QbD Group",
      description: "Aprende a utilizar el grouping y el worksharing conforme a las Directrices de variaciones de la UE de 2025 para coordinar las solicitudes y mejorar la planificación del ciclo de vida.",
    } : {}),
  component: BlogPost,
});

